import React from 'react'

const ExtendedWArrantyApprovalDetails = () => {
  return (
    <div>ExtendedWArrantyApprovalDetails</div>
  )
}

export default ExtendedWArrantyApprovalDetails